import { FilterComboBoxMenuItem, highlight, MenuItemProps } from '../filter-combo-box/filter-combo-box-menu-item';
import { MenuItem, MenuItemWithTag } from '../filter-combo-box/filter-combo-box.types';

const tagStyles =
  'whitespace-nowrap self-start bg-white rounded mr-1 normal-case inline-block rounded-sm py-1 px-2 text-xs font-medium text-gray-900';

export const renderPALItem = <T extends MenuItemWithTag>(item: T) => (
  <div className="flex items-stretch">
    <div className="w-10">
      {item.tagLeftIcon
        ? item.tagLeftIcon({ className: 'h-full w-4 float-right mr-1 inline text-gray-800 fill-current' })
        : undefined}
    </div>
    <div className="grow pl-3">
      <div>{highlight(item.label, item.textToHighlight)}</div>
      <div className="pt-1 text-xs text-gray-700">{item.subtext}</div>
    </div>
    <div className={tagStyles}>{highlight(item.tagText ?? '', item.textToHighlight)}</div>
  </div>
);

export const PALFilterMenuItem = <T extends MenuItem>(props: MenuItemProps<T>) => {
  const { renderItem = renderPALItem, ...rest } = props;
  return <FilterComboBoxMenuItem renderItem={renderItem} {...rest} />;
};
